<template>
  <div class="real-auth-result">
    <img v-if="isPass === 'true'" :src="$setPicSize(successImg)" />
    <img v-if="isPass === 'false'" :src="$setPicSize(failImg)" />
    <div class="result-info">
      <header v-if="isPass === 'true'">恭喜您认证成功</header>
      <header v-if="isPass === 'false'">很遗憾认证失败</header>
      <div class="desc">{{ copywriting }}</div>
    </div>
    <div class="operation-area">
      <div
        v-for="ctx in buttonCtxes"
        :key="ctx.type"
        @click="doCommand(ctx)"
        :class="ctx.style"
      >
        <span>{{ ctx.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import setPicSize from '@zz-app/setPicSize'
// import { lego } from '@zz-common/lego'
import { toast } from '../../native'
import { queryParams, skipClose } from '../../lib/utils'
// import DAL from '../../dal'
import { getsdkcallbacktext, getuserauthcardinfo } from '../../api/resourceApi';

const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    return {
      code: query.code || this.$route.query.code,
      agreementNo: query.agreementNo || this.$route.query.agreementNo,
      sourcecode: query.sourcecode || this.$route.query.sourcecode,
      // 认证结果
      isPass: '',
      zljToken: '',
      copywriting: '',
      buttonCtxes: [],
      successImg: 'f9436be4-ddfb-4f7b-8047-f0ae914e714c.png',
      failImg: '2980c180-8a0e-48e5-9ffb-ec7ad3ec4766.png'
    }
  },
  mounted() {
    native.setTitle({
      title: '实名认证'
    })
    native.wrap('getUserInfo')({
      success: (res) => {
        if (!res) {
          const now = new Date()
          return console.log('读取APP用户信息失败:getUserInfo method error!' + now + '.' + now.getMilliseconds())
        }
        const { token } = res
        this.zljToken = token;
      }
    })
    console.log('this.zljToken', this.zljToken);
    // 身份号认证获取页面文案信息
    getsdkcallbacktext({
      sourcecode: this.sourcecode,
      code: this.code,
      agreementNo: this.agreementNo
    })
      .then((res) => {
        this.isPass = res.isPass
        this.copywriting = res.copywriting
        this.adapterButtonCtxes(res.retButtons)
      })
      .catch((err) => {
        console.error(err)
        toast({
          msg: err,
          style: '2'
        })
      })
  },
  methods: {
    $setPicSize(url) {
      return setPicSize(url, 500, 500)
    },
    // 处理按钮展示逻辑
    adapterButtonCtxes(data) {
      const buttonData = data.map((b) => {
        return {
          cmd: b.type,
          targetUrl: b.mUrl,
          text: b.buttonDesc,
          style: b.style || 'normal'
        }
      })
      this.buttonCtxes = buttonData
    },
    //处理按钮
    doCommand(ctx) {
      // 关闭页面
      if (ctx.cmd === 'close') {
        native.close()
      } else if (ctx.cmd === 'jump') {
        skipClose(ctx.targetUrl)
        // 人工审核
        // native.skipToUrl({
        //   targetUrl: ctx.targetUrl,
        //   needClose: '1'
        // })
        // setTimeout(() => {
        //   native.close();
        // }, 100)
      } else if (ctx.cmd === 'reverify') {
        // 重新认证
        getuserauthcardinfo({
          agreementno: this.agreementNo,
          zljToken: this.zljToken,
          sourcecode: this.sourcecode
        })
          .then((res) => {
            localStorage.setItem('userCardNo', res.userCardNo)
            localStorage.setItem('userName', res.userName)
          })
          .catch((err) => {
            console.error(err)
            toast({
              msg: err.message || '获取用户实名失败',
              style: '2'
            })
          })
        const targetUrl = `https://feentry.zhuanzhuan.com/auth_face?clientid=ZLJRealAuthCommitInfo&sourcecode=${this.sourcecode}&authtype=reverify`
        skipClose(targetUrl);

        // native.skipToUrl({
        //   targetUrl: `https://feentry.zhuanzhuan.com/auth_face?clientid=ZLJRealAuthCommitInfo&sourcecode=${this.sourcecode}&authtype=reverify`,
        //   newPageTitle: '实人认证',
        //   needClose: '1'
        // })
        // setTimeout(() => {
        //   native.close();
        // }, 100);
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'result.less';
</style>
